import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useError } from '../../contexts/error-context'

import './index.css'

/**
 * Error page: 404 (with the missing path), 401 "not published yet" (with the opening date when the
 * context has one), or the generic error. The copy and the context reads are unchanged; the page
 * now uses the kit's empty-state look and offers a way back home.
 */
export default function NotFound() {
    const errorContext = useError()
    const { t } = useTranslation()

    const GetErrorTitle = () => {
        if (errorContext.error?.type == 401) {
            return t('This page is currently not published')
        }
        if (
            errorContext.error?.type == 404 &&
            errorContext.error?.PUBLISH_TYPES &&
            errorContext.error?.published !== undefined
        ) {
            return t(
                'Le {{PUBLISH_TYPES}} de cet événement n’est pas publié ! Veuillez vous rapprocher de l’organisateur.',
                { PUBLISH_TYPES: errorContext.error?.PUBLISH_TYPES.toLowerCase() },
            )
        }
        if (errorContext.error?.type == 404) {
            return t('Page not found')
        }
        if (errorContext.error) {
            return t('Oops, an error occurred !')
        }
        return t('Page not found')
    }

    const GetErrorMessage = () => {
        if (errorContext.error?.type == 404 && errorContext.error?.location?.pathname) {
            return errorContext.error.location.pathname
        }
        if (errorContext.error?.type == 401 && errorContext.error?.open_date) {
            return t('Start date: {{date}}', { date: errorContext.error?.open_date })
        }
        return ''
    }

    const message = GetErrorMessage()

    return (
        <div className="not-found">
            <span className="not-found-ico" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                    <path d="M12 9v4M12 16.5v.5" />
                    <path d="M10.3 4.6 3.2 17.2A2 2 0 0 0 5 20.2h14a2 2 0 0 0 1.8-3L13.7 4.6a2 2 0 0 0-3.4 0z" />
                </svg>
            </span>
            <h1>{GetErrorTitle()}</h1>
            {message && <p className="not-found-sub">{message}</p>}
            <Link to="/" className="not-found-home">
                {t('Back to home')}
            </Link>
        </div>
    )
}

